import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer dark:bg-slate-950 dark:text-slate-400">
      <div className="container">
        <div className="flex flex-wrap items-center justify-center gap-4 text-sm mb-2">
          <Link to="/terms" className="text-blue-600 dark:text-brand-secondary underline hover:text-blue-800">
            Terms &amp; Conditions
          </Link>
          <Link to="/privacy" className="text-blue-600 dark:text-brand-secondary underline hover:text-blue-800">
            Privacy Policy
          </Link>
        </div>
        <p>&copy; {new Date().getFullYear()} TELLURVISION. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
